import { Event } from '@/event-bus/event';

export class TransitionFailedEvent extends Event<Error> {}
